<template>
  <div class="customer-page">
    <div class="search_box">
      <van-search v-model="searchValue" placeholder="请输入客户姓名或手机号" show-action>
        <template #action>
          <div class="searchBtnBox">
            <span @click="onSearch">
              <img src="./img/search.png" alt />
            </span>
          </div>
        </template>
      </van-search>
    </div>
    <div class="content_customer">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          class="customer_list"
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
        >
          <van-row class="listWrap">
            <div class="list_item" v-for="item in customerList" :key="item">
              <div class="pic_wrap">
                <!-- <van-image
                  height="80"
                  width="80"
                  :src="item.showListImgUrl"
                  fit="cover"
                  error-icon
                />-->
                <img src="./img/icon-default.png" alt />
              </div>
              <div class="van-multi-ellipsis--l2 text_wrap">
                <p>
                  <span
                    style="color:#666display: inline-block;max-width: 50px;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;"
                  >{{item.insuredname}}</span>
                  <span style="color:#666">
                    &nbsp;&nbsp;
                    <a style="color:#1f90fd" :href="'tel:'+ item.tel">{{item.tel}}</a>
                  </span>
                </p>
                <p v-if="item.activitieName">
                  <span>
                    来自活动：
                    <i class="activitieName">{{item.activitieName}}</i>
                  </span>
                </p>
                <p>
                  <span>创建时间：{{item.createdate.substr(0,10)}}</span>
                </p>
              </div>
              <div class="editBtn" @click="editCustomer(item.insuredcode)">
                <img src="./img/contanctBtn.svg" alt />
              </div>
              <div class="delBtn" @click="delCustomer(item.insuredcode)">
                <img src="./img/delBtn0.png" alt />
              </div>
            </div>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-dialog v-model="delTip" title="确定要删除该条客户信息么？" @confirm="confirmDel" show-cancel-button></van-dialog>
  </div>
</template>

<script>
import { Toast } from "vant";
import URL from "@/api/api";
export default {
  name: "home",
  data() {
    return {
      searchValue: "",
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1, //请求第几页
      pageSize: 10, //每页请求的数量
      total: 0, //总共的数据条数
      customerList: [],
      finishedText: '我也是有底线的~~~',
      clueTimeTypes: [
        { type: "0", name: "全部", isActive: false },
        { type: "7", name: "近7天", isActive: true },
        { type: "30", name: "近30天", isActive: false }
      ],
      firstTransferPerson: '',
      userId: '',
      headimgurl: '',
      nickname: '',
      activitie_id: '',
      tendsType: '',
      delTip: false,
      insuredcode: '',
    };
  },
  created() {
    Toast.loading({
      message: "加载中...",
      duration: 0,
      forbidClick: true
    });
  },
  mounted() {
    this.activitie_id = this.$route.query.activitie_id;
    this.tendsType = this.$route.query.tendsType;
    this.userId = this.$route.query.userId;
    this.headimgurl = this.$route.query.headimgurl;
    this.nickname = this.$route.query.nickname;
    if (location.hostname === "ufc.dtfcloud.com") {
      this.appId = "wxae0168c583647722";
    } else {
      this.appId = "wxae0168c583647722";
    }

    this.firstTransferPerson = this.$route.query.firstTransferPerson;
    // this.firstTransferPerson=this.$store.state.openId;
    // this.$store.state.code = this.getUrlParams("code"); //获取code
    // if (!this.$store.state.code) {
    //   this.goAuthorize();
    // } else {
    //   if(this.$store.state.openId){
    this.getDataList();
    //      return
    //   }
    //   this.getOpenID();
    // }

  },
  methods: {
    initialization() {
      this.customerList = [];
      this.pageNum = 1;
      this.loading = true; //下拉加载中
      this.finished = false; //下拉结束
      if (this.loading) {
        this.onLoad();
      }
    },
    getDataListByTime(time) {
      this.customerList = [];
      for (var j = 0; j < this.clueTimeTypes.length; j++) {
        this.clueTimeTypes[j].isActive = false;
      }
      time.isActive = true;
      this.clueTimeType = time.type;
      this.initialization();
      // this.getDataList(this.clueType,time.type,'1')
    },
    getDataList() {
      let that = this;
      let postData = {
        pageNo: that.pageNum,
        pageSize: that.pageSize,
        firstTransferPerson: that.firstTransferPerson,
        // firstTransferPerson:"o79BZsyhwH-UdEXw2dKiTbSm5w1s",
        customer_name: that.searchValue
      }
      that.$fetchPost(URL.queryAisCustomers.url,postData).then(res => {
        let list = res.data.data.list; //请求返回当页的列表
        that.refreshing = false;
        that.loading = false;
        Toast.clear();
        that.total = res.data.data.total;
        if (list == null || list.length === 0) {
          // 加载结束
          that.finished = true;
          that.finishedText = '暂无数据'
          return;
        }
        // 将新数据与老数据进行合并
        if (this.pageNum > 1) {
          that.customerList = [...that.customerList, ...list];
        } else {
          that.customerList = list;
        }
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.customerList.length >= that.total) {
          that.finished = true;
          that.finishedText = '我也是有底线的~~~'
        }
        // 如果总页数大于当前页码，页码+1
        if (res.data.data.pages > that.pageNum) {
          that.pageNum++;
        }
      });
    },
    onLoad() {
      this.getDataList();
    },
    onRefresh() {
      this.searchValue = "";
      this.pageNum = 1;
      this.finished = false;
      this.getDataList();
    },
    onSearch() {
      (this.searchValue);
      this.finished = false;
      this.customerList = [];
      this.pageNum = 1;
      this.getDataList();
    },
    getClueDetails(item, type) {
      let that = this;
      if (this.clueType == "Article") {
        this.$router.push({
          name: "custoemrDetails",
          query: {
            activitie_id: item.artcId,
            tendsType: type
          }
        });
      }
    },
    delCustomer(insuredcode) {
      this.insuredcode = insuredcode;
      this.delTip = true;
    },
    confirmDel() {
      var that = this;
      that.$fetchGet(URL.deleteCustomer.url, { insuredcode: that.insuredcode }).then(res => {
        if (res.data.code === 20000) {
          that.getDataList();
        } else {
          Toast(res.data.msg);
        }
      });
    },
    addCustomer() {
      this.$router.push({
        name: "customerDetails",
        query: {
          type: 'add',
          // tendsType: type
        }
      });
    },
    checkCustomer(userId) {
      this.$router.push({
        name: "customerDetails",
        query: {
          type: 'check',
          userId: userId
        }
      });
    },
    editCustomer(insuredcode) {
      var that = this;
      this.$router.push({
        name: "customerDetails",
        query: {
          type: 'edit',
          insuredcode: insuredcode,
          userId: that.userId,
          nickname: that.nickname,
          headimgurl: that.headimgurl,
          activitie_id: that.activitie_id,
          tendsType: that.tendsType
        }
      });

    }
  }
};
</script>

<style lang="less">
.customer-page {
  position: relative;
  height: 100%;
  font-size: 14px;
  .tab {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    background: #fff;
    // display: flex;
    .van-tab {
      font-size: 16px;

    }
    .tabBox_time {
      display: flex;
      text-align: center;
      font-size: 14px;
      // width: 90%;
      margin: 0 auto;
      height: 30px;
      line-height: 30px;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      div {
        height: 30px;
        line-height: 30px;
        flex: 1;
        background: #fff;
        border-radius: 3px;
        margin: 10px 10px;
        font-size: 14px;
      }
      .active {
        color: #1f90fd;
        text-decoration: underline;
      }
    }
  }
  .search_box {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 9999;
      .searchBtnBox{
        span{
          width: 20px;
          display: inline-block;
          text-align: center;
          border-radius: 3px;
          color: #fff;
          margin: 0 10px;
          // background: #1f90fd;
          img{
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;;
          }
        }
      }
    }
  .content_customer {
    padding: 58px 0 44px;
    // height: 100%;
    display: flex;
    flex: 1;
    background: #f5f5f5;;
    // overflow-y: auto;
    .van-pull-refresh{
      width: 100%;
      .customer_list {
        width: 100%;
        .van-row {
          width: 100%;
          .list_item {
            width: 100%;
            background: #fff;
            margin-bottom: 4px;
            position: relative;
            padding: 6px 12px;
            .clueNum {
              position: absolute;
              width: 70%;
              right: 0;
              bottom: 5px;
              display: flex;
              p {
                color: #1f90fd;
                flex: 1;
                span {
                  img {
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    vertical-align: top;
                  }
                }
              }
            }
            .pic_wrap {
              position: relative;
              padding: 5px 0;
              .badge {
                position: absolute;
                bottom: 4px;
                right: 0;
                width: 46px;
                height: 18px;
                line-height: 18px;
                background-color: #5b9bd5;
                color: #fff;
                text-align: center;
                font-size: 12px;
              }
              img{
                border-radius: 3px;
                width: 60px;
                height: 60px;
              }
            }
            .text_wrap {
              font-size: 16px;
              color: #737373;
              position: absolute;
              width: 55%;
              top: 15px;
              left: 100px;
              p{
                line-height: 20px;
                margin-bottom: 5px;
                span{
                  display: inline-block;
                  i.activitieName{
                    display: inline-block;
                    max-width: 70px;
                    // background: red;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    position: relative;
                    font-style: normal
                    // top: 5px;
                  }
                }
              }
            }
            .delBtn{
              width: 20px;
              line-height: 30px;
              // background: #1f90fd;
              color: #fff;
              position: absolute;
              right: 20px;
              top: 16px;
              border-radius: 3px;
              text-align: center;
              img{
                width: 20px;
                height: 20px;
              }
            }
            .editBtn{
              width: 20px;
              line-height: 30px;
              // background: #1f90fd;
              color: #fff;
              position: absolute;
              right: 60px;
              top: 16px;
              border-radius: 3px;
              text-align: center;
              img{
                width: 20px;
                height: 20px; 
              }
            }
          }
        }
      }
      .van-list {
        /deep/ .van-list__error-text,
        /deep/ .van-list__finished-text,
        /deep/ .van-list__loading {
          width: 100%;
        }
      }
    }
  }
  .publish {
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
</style>
